module.exports = __webpack_public_path__ + "static/media/happy_easter_map_important.9a24fbd7.svg";